import React from 'react';
import { DecoratorNode } from 'lexical';

// eslint-disable-next-line import/no-cycle
import { TermTranslationComponent } from './TermTranslationComponent';

class TermTranslationNode extends DecoratorNode {
  constructor(text, definition, key) {
    super(key);
    this.text = text;
    this.definition = definition;
  }

  static importJSON(serializedNode) {
    return new TermTranslationNode(serializedNode.text, serializedNode.definition);
  }

  exportJSON() {
    return {
      type: 'term',
      version: 1,
      text: this.text,
      definition: this.definition
    };
  }

  static getType() {
    return 'term';
  }

  static clone(node) {
    return new TermTranslationNode(node.text, node.definition, node.__key);
  }

  createDOM() {
    const span = document.createElement('span');
    span.className = 'highlighted-text';
    span.setAttribute('data-tooltip', this.definition);
    return span;
  }

  // eslint-disable-next-line class-methods-use-this
  updateDOM() {
    return false;
  }

  decorate() {
    return (
      <TermTranslationComponent
        nodeKey={this.getKey()}
        data={{ definition: this.definition }}
        value={this.text}
      />
    );
  }

  getTextContent() {
    return this.text;
  }
}

export { TermTranslationNode };

export const $isTermTranslationNode = (node) => node instanceof TermTranslationNode;
